import { POSSIBLE_MODAL_ALERT_CONTENTS } from "constants/brands";

export const MODAL_TITLES = {
  [POSSIBLE_MODAL_ALERT_CONTENTS.FORM_ALERT]: "Brand Alert Settings",
  [POSSIBLE_MODAL_ALERT_CONTENTS.SUCCESS_FEEDBACK]: "Nicely Done!",
  [POSSIBLE_MODAL_ALERT_CONTENTS.CANCEL_ALERT_FEEDBACK]:
    "Your brand alert has been cancelled"
};

export const BRAND_ALERT_INITIAL_CONTEXT = {
  isInitialLoading: true,
  currentContent: POSSIBLE_MODAL_ALERT_CONTENTS.FORM_ALERT,
  getUserBrandAlerts: async () => {},
  cancelAlert: async ({ productSourceId }) => {},
  resetAlert: async () => {},
  saveBrandAlert: async (params) => {},
  getCurrentBrandAlert: ({ productSourceId }) => {},
  setCurrentContent: (content) => {},
  productSourceId: null,
  setProductSourceId: (value) => {}
};
